var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 73 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Crown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6192 35.4828C19.9182 28.9078 20.2276 22.1036 20.5474 15.0703L33.1661 32.825L27.9567 39.7L19.6192 35.4828Z",
    fill: "var(--fill-0, #D7981A)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M52.9067 35.4828C52.6234 28.9078 52.3302 22.1036 52.027 15.0703L39.3708 32.825L44.563 39.7L52.9067 35.4828Z",
    fill: "var(--fill-0, #D7981A)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M58.2708 45.4297H14.0255L12.0974 36.1187H60.202L58.2708 45.4297Z",
    fill: "var(--fill-0, #EFBD42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.8567 40.2594C9.8359 32.6552 6.69371 24.7354 3.43017 16.5C8.926 20.7708 14.3093 24.9547 19.5802 29.0516C23.3458 31.9797 28.6145 30.4578 30.2567 25.9266L37.5833 5.72656C39.9567 14.3375 41.9333 21.525 43.613 27.6078C44.5505 31.0344 48.5005 32.2719 51.2036 30.0078L68.8739 15.2109L59.0458 41.2547L12.8567 40.2594Z",
    fill: "var(--fill-0, #EFBD42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M59.6255 45.4297H12.6708L12.2177 38.0797H60.0802L59.6255 45.4297Z",
    fill: "var(--fill-0, #EFBD42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M59.6255 45.4297C59.5349 46.8984 49.0239 48.0859 36.1474 48.0859C23.2708 48.0859 12.7614 46.9031 12.6708 45.4297C12.5802 43.9562 23.0911 42.7406 36.152 42.7406C49.213 42.7406 59.7177 43.95 59.6255 45.4297Z",
    fill: "var(--fill-0, #D7981A)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M37.5817 9.06563C39.2213 9.06563 40.5505 7.03621 40.5505 4.53281C40.5505 2.02941 39.2213 -4.76837e-07 37.5817 -4.76837e-07C35.9421 -4.76837e-07 34.613 2.02941 34.613 4.53281C34.613 7.03621 35.9421 9.06563 37.5817 9.06563Z",
    fill: "var(--fill-0, #86EBF9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M5.19998 18.6081C6.13089 17.9725 6.09881 16.305 5.12832 14.8837C4.15784 13.4624 2.61646 12.8255 1.68556 13.4611C0.75465 14.0967 0.78673 15.7642 1.75721 17.1855C2.72769 18.6068 4.26907 19.2437 5.19998 18.6081Z",
    fill: "var(--fill-0, #E73F46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M20.7867 17.16C21.6905 16.8964 22.0971 15.5645 21.6948 14.1852C21.2925 12.8059 20.2337 11.9014 19.3299 12.165C18.426 12.4286 18.0195 13.7605 18.4218 15.1398C18.8241 16.5191 19.8829 17.4236 20.7867 17.16Z",
    fill: "var(--fill-0, #917EEC)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M53.571 14.8998C53.9733 13.5205 53.5668 12.1886 52.663 11.925C51.7592 11.6614 50.7003 12.5659 50.298 13.9452C49.8957 15.3245 50.3023 16.6564 51.2061 16.92C52.1099 17.1836 53.1687 16.2791 53.571 14.8998Z",
    fill: "var(--fill-0, #917EEC)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M70.5873 16.2387C71.5578 14.8174 71.5899 13.1499 70.659 12.5143C69.7281 11.8787 68.1867 12.5156 67.2162 13.9369C66.2457 15.3582 66.2136 17.0257 67.1446 17.6613C68.0755 18.2969 69.6168 17.66 70.5873 16.2387Z",
    fill: "var(--fill-0, #E73F46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M36.3927 31.6656C35.9239 30.1031 34.8005 29.1172 33.7286 29.1531C32.7161 29.1891 31.9067 30.1344 31.6317 30.8719C30.902 32.8375 33.0052 35.8406 36.7192 38.4875C40.1255 35.6484 41.9833 32.5813 41.1458 30.6828C40.8833 30.0891 40.2192 29.2906 39.3286 29.1969C38.238 29.0875 37.0255 30.0516 36.3927 31.6656Z",
    fill: "var(--fill-0, #CC3745)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M1.64267 14.2516C1.77969 15.0631 2.08979 15.8356 2.5519 16.5167C3.01401 17.1977 3.61731 17.7713 4.32079 18.1984C3.85147 18.1222 3.40369 17.9472 3.00717 17.6848C2.61064 17.4224 2.27442 17.0787 2.02079 16.6766C1.58905 15.9464 1.45372 15.0785 1.64267 14.2516Z",
    fill: "var(--fill-0, #E5E5E5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M37.1052 0.646874C34.4489 2.69375 34.6755 6.25469 37.1052 8.34219C36.3635 7.19595 35.9689 5.85979 35.9689 4.49453C35.9689 3.12928 36.3635 1.79311 37.1052 0.646874Z",
    fill: "var(--fill-0, #E5E5E5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M66.988 16.6187C66.952 14.4984 68.252 12.6422 70.3989 12.8687C68.6099 13.3984 67.402 14.8312 66.988 16.6187Z",
    fill: "var(--fill-0, #E5E5E5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M5.37079 19.8219L12.5895 35.3719L14.4411 33.7578L5.37079 19.8219Z",
    fill: "var(--fill-0, #E5E5E5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M13.0677 36.7359L13.5177 43.6984L15.7911 42.9078L15.0583 35.5266L13.0677 36.7359Z",
    fill: "var(--fill-0, #E5E5E5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M36.1333 32.1656C35.477 30.8078 34.4895 29.9453 33.6333 30.0422C33.3536 30.079 33.0899 30.1938 32.8724 30.3734C32.377 30.8188 32.3895 31.5469 32.4036 31.9078C32.4395 33.875 35.9849 37.1438 36.1536 37.3016C36.1526 35.587 36.1458 33.875 36.1333 32.1656Z",
    fill: "var(--fill-0, #E73F46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M37.1052 10.5641L36.1489 27.3859H31.9489L37.1052 10.5641Z",
    fill: "var(--fill-0, #E5E5E5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M31.2349 35.1969V41.5031H35.3208V38.925L31.2349 35.1969Z",
    fill: "var(--fill-0, #E5E5E5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M65.6661 18.975L52.6552 31.7719L55.9864 33.4156L65.6661 18.975Z",
    fill: "var(--fill-0, #D7981A)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M54.9161 42.5344L51.5442 41.8609L52.1395 32.975L55.4317 34.4031L54.9161 42.5344Z",
    fill: "var(--fill-0, #D7981A)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingStandard);
export default __webpack_public_path__ + "static/media/pricing-standard.2bd44dfa0eba2cfbb26eb036286d6e68.svg";
export { ForwardRef as ReactComponent };